import { render, staticRenderFns } from "./NotAccessPage.vue?vue&type=template&id=df8b2158&"
import script from "./NotAccessPage.vue?vue&type=script&lang=js&"
export * from "./NotAccessPage.vue?vue&type=script&lang=js&"
import style0 from "./NotAccessPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports